module.exports = __webpack_public_path__ + "img/pointB_gr1_3.d63b7bfc.png";